// extracted by mini-css-extract-plugin
export default {"content":"ChipCell-module__content__ztvjA"};